export default {
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
};
